import React, { useEffect } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import GrabButton from "../../../Button/GrabButton";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import theBG1 from "../../../../assets/images/drink3.png";
import AOS from "aos";
import "aos/dist/aos.css";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "transparent",
    color: "white",
    background: "linear-gradient(270deg, #2a4343, #4b7474)",
    backgroundSize: "400% 400%",
    WebkitAnimation: "breath 3s ease infinite",
    MozAnimation: "breath 3s ease infinite",
    animation: "breath 3s ease infinite",
    padding: "1rem",
  },
  media: {
    height: 250,
  },
}));

export default function Drink() {
  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Card className={classes.root} elevation="0">
      <CardMedia
        className={classes.media}
        image={theBG1}
        title="food"
        data-aos="zoom-in"
        data-aos-duration="1000"
      />
      <CardContent data-aos="fade-right" data-aos-duration="1000">
        <Typography
          data-aos="zoom-in"
          data-aos-duration="1000"
          gutterBottom
          variant="h5"
          component="h2"
          style={{ fontWeight: 300 }}
        >
          Đồ uống
        </Typography>
        <Typography variant="body2" component="p">
          Sài Gòn đôi khi mang cái nắng nóng khiến những buổi tập gym của chúng
          ta trở nên mệt mỏi. Do đó, dưới sự sắp xếp của Bếp trưởng từng đoạt
          giải thưởng, O Như đã chọn món Chanh xả mật ong để xây dựng bước đi
          đầu tiên cho một bữa ăn sáng chất lượng và ngon miệng.
        </Typography>
      </CardContent>
      <CardContent data-aos="fade-left" data-aos-duration="1000">
        <Typography variant="body2" component="p">
          Ông cha ta khẳng định Sả, Chanh và Mật ong đều là những nguyên liệu tự
          nhiên, thân thiện với sức khỏe người dùng. Hơn nữa, kiên trì sử dụng
          nước sả, chanh, mật ong giúp cơ thể tăng cường sức đề kháng , ngăn
          ngừa vi khuẩn xâm nhập, đồng thời đẩy lùi một số tế bào bệnh nguy hiểm
          cho sức khỏe.
        </Typography>
      </CardContent>
      <CardContent data-aos="fade-right" data-aos-duration="1000">
        <Typography variant="body2" component="p">
          Người xưa từ lâu ví Sả như một dược liệu quý có công dụng giảm huyết
          áp hiệu quả. Mật ong, một dược liệu quý thứ hai, chứa những thành phần
          dưỡng chất tốt cho sức khỏe. Vì vậy, 2 dược liệu quý kết hợp sẽ hỗ trợ
          người bệnh cao huyết áp kiểm soát tốt chỉ số sức khỏe, chống tăng
          lượng cholesterol, giảm nguy cơ mắc những bệnh tim mạch. Do đó, O Như
          chọn nước sả cây và chanh giúp bạn bắt đầu một ngày mới với nhiều
          dưỡng chất cần thiết!
        </Typography>
      </CardContent>
      <CardActions style={{ display: "flex", flexDirection: "column" }} data-aos="zoom-in" data-aos-duration="1000">
        <GrabButton />
        <Typography
          variant="body1"
          style={{
            padding: theme.spacing(2),
            fontWeight: "bold",
          }}
        >
          HOẶC
        </Typography>
        <Typography variant="body1">
          <a
            href="https://www.google.com/maps/place/B%C3%BAn+B%E1%BA%AFp+B%C3%B2+O+Nh%C6%B0/@10.7400125,106.6757078,17z/data=!4m13!1m7!3m6!1s0x31752faceb2a9621:0x54ec2b6171781878!2zMTM0IMSQxrDhu51uZyBDYW8gTOG7lywgUGjGsOG7nW5nIDQsIFF14bqtbiA4LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmg!3b1!8m2!3d10.7400125!4d106.6778965!3m4!1s0x31752fcbf2b71fef:0xff4b8413fe51f530!8m2!3d10.7400125!4d106.6778965"
            target="_blank"
            rel="noreferrer"
            style={{ color: "white", textTransform: "uppercase" }}
          >
            Ăn tại quán!
          </a>
        </Typography>
      </CardActions>
    </Card>
  );
}
